<template>
  <div id="index">
        <ul>
        <li><a href="./">首页</a></li> >
        <li>知识库</li>
    </ul>

      <Add v-if="iShowAdd"></Add>
      <Content></Content>
      <TagsList style="float:right"></TagsList>
  </div>
</template>
<script>
import Content from './Content'
import TagsList from './TagsList'
import Add from './Add'

export default {
  data(){
    return{
    }
  },
  components:{
      Content,
      TagsList,
      Add
  },
  created(){
  },
  computed:{
    iShowAdd:function(){
      return sessionStorage.getItem('type') !== 'G'
    }
  },
  beforeCreate(){
    if(!sessionStorage.getItem('loginkey')){
      console.log('没登录')
      this.$router.push('/login');
    }else{
      // var params = new URLSearchParams();
      // params.append('name', sessionStorage.getItem('name'));
      // params.append('loginkey', sessionStorage.getItem('loginkey'));
      
      // this.$http.post('http://'+this.IP+'/api/getUserInfo.php',params)
      // .then((res)=>{
      //   if(res.data[0]['permission'] == 1111){
      //     this.$store.state.isAdmin = true;
      //   }else{
      //     this.$store.state.isAdmin = false;
      //   }
      // })
    }
  }
}
</script>
<style scoped>
  #index{
    max-width: 90%;
    margin: 0 auto;
  }
  ul{
    margin: 20px 0;
    font-size: 14px;
    color: #aaa
  }
  li{
      display: inline;
  }
  li a{
      text-decoration: none;
  }

</style>




// WEBPACK FOOTER //
// src/components/Index.vue